export const EntranceTypeByType = new Map<string, any>([
  ['activity', { type: 'activity', title: 'Aktivitäten' }],
  ['alphabet', { type: 'alphabet', title: 'Alphabet' }],
  ['breaking-news', { type: 'breaking-news', title: 'Breaking News' }],
  ['event', { type: 'event', title: 'Events' }],
  ['feedback', { type: 'feedback', title: 'Feedback' }],
  ['gallery', { type: 'gallery', title: 'Gallery' }],
  ['gastronomy', { type: 'gastronomy', title: 'Gastronomie' }],
  ['information', { type: 'information', title: 'Information' }],
  ['important-numbers', { type: 'important-numbers', title: 'Wichtige Nummern' }],
  ['opening-hours', { type: 'opening-hours', title: 'Öffnungszeiten' }],
  ['offer', { type: 'offer', title: 'Offer' }],
  ['person', { type: 'person', title: 'Person' }],
  ['quiz', { type: 'quiz', title: 'Quiz' }],
  ['restaurant', { type: 'restaurant', title: 'Restaurants' }],
  ['roomservice', { type: 'offer', title: 'Roomservice' }],
  ['screensaver', { type: 'screensaver', title: 'Screensaver' }],
  ['social-media', { type: 'social-media', title: 'Social Media' }],
  ['ticker', { type: 'ticker', title: 'Ticker' }],
  ['voting', { type: 'voting', title: 'Voting' }],
  ['voucher', { type: 'voucher', title: 'Voucher' }],
  ['webcam', { type: 'webcam', title: 'Webcams' }]
]);
